import React, { useRef, useEffect } from 'react';
import { Logger } from '@aws-amplify/core';
const logger = new Logger('VideoTrack', 'INFO');
export default function VideoTrack({ track, isLocal, priority, customStyle }) {
    const ref = useRef(null);
    logger.debug(`VideoTrack re-rendered for track ${track === null || track === void 0 ? void 0 : track.name}`);
    useEffect(() => {
        const el = ref.current;
        return () => {
            if (track) {
                logger.debug(`Ref has changed for video Track ${track.name} detatching`);
                track.detach(el);
                el.src = '';
                el.load();
            }
        };
    }, [ref]);
    useEffect(() => {
        return () => {
            logger.debug('Component is disappearing!!!');
        };
    }, []);
    useEffect(() => {
        logger.debug(`Track change ${track === null || track === void 0 ? void 0 : track.name}`);
        if (track) {
            const el = ref.current;
            el.muted = true;
            if (track.setPriority && priority) {
                track.setPriority(priority);
            }
            track.attach(el);
            return () => {
                logger.debug(`Cleanup called for track ${track.name} src: ${el.currentSrc}, `);
                track.detach(el);
                logger.debug(`Post detatch src: ${el.currentSrc}, ${el.ended} ${el.paused} ${el.srcObject}`);
                el.srcObject = null;
                if (track.setPriority && priority) {
                    // Passing `null` to setPriority will set the track's priority to that which it was published with.
                    track.setPriority(null);
                }
            };
        }
    }, [track, priority]);
    // The local video track is mirrored.
    const isFrontFacing = track && track.mediaStreamTrack.getSettings().facingMode !== 'environment';
    let style = isLocal && isFrontFacing ? { transform: 'scale(-1,1)' } : {};
    style = Object.assign(Object.assign(Object.assign({}, style), { objectFit: 'contain', width: '100%', maxHeight: '100%', display: track ? '' : 'none' }), customStyle);
    return React.createElement("video", { ref: ref, style: style });
}
//# sourceMappingURL=VideoTrack.js.map